export const PricingTierFeaturesList: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <div className='my-6 flex flex-col gap-3'>{children}</div>;
};
